module.exports = __webpack_public_path__ + "media/images/flags/32/Democratic-Republic-of-the-Congo-c0baa728fdf1e632e94591ef980759a9.png";